import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-grid-system";
import { MdOutlineShoppingBag } from "react-icons/md";
import { PiTruckFill } from "react-icons/pi";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Dimmer, Icon, Loader } from "semantic-ui-react";
import { ClientProductModel } from "../../entities/product.model";
import { ProviderModel } from "../../entities/provider.model";
import store from "../../store";
import { getEffectivePrice, isEmpty } from "../../utils/shared.utils";
import TopProductItem from "../top-product-item/top-product";
import TopProducts from "../top-products/top-products";
import "./product-page.scss";

function productSharesCategory(p: any, categoryId: number | undefined) {
  if (categoryId === undefined || categoryId === null) {
    return false;
  }
  const id = Number(categoryId);
  if (Array.isArray(p.categoryIds) && p.categoryIds.length > 0) {
    return p.categoryIds.some((x: any) => Number(x) === id);
  }
  return Number(p.categoryId) === id;
}

interface ProductProps {
  product: ClientProductModel;
  brand: any;
  category: any;
  subCategory: any;
  clientLoggedIn: boolean;
  savedProduct: boolean;
  settings: any;
  deliveryDateMin: any;
  deliveryDateMax: any;
  deliveryTime: any;
  categoryProducts: any[];
}

const mapStateToProps = (state: any, props: any) => {
  let product: any = {};
  let brand;
  let category: any = {};
  let subCategory;
  let basketCount = 0;

  for (let p of state.products) {
    if (p.slug == props.match.params.slug) {
      product = p;
      if (state.basket && state.basket.quantityById) {
        if (
          state.basket.quantityById[p.id] !== null &&
          state.basket.quantityById[p.id] !== undefined
        ) {
          // exists in the basket
          basketCount = state.basket.quantityById[product.id];
        }
      }
      break;
    }
  }

  if (!product) return {};

  for (let b of state.brands) {
    if (b.id == product.brandId) {
      brand = b;
      break;
    }
  }

  for (let c of state.categories) {
    if (c.id == product.categoryId) {
      category = c;
    }

    for (let s of c.subCategories) {
      if (s.id == product.subCategoryId) {
        subCategory = s;
      }
    }
  }

  let clientLoggedIn = false;
  let savedProduct = false;

  if (state.client && state.client.id) {
    clientLoggedIn = true;
    if (product && state.client && state.client.savedProducts) {
      for (let p of state.client.savedProducts) {
        if (p.productId === product.id) {
          savedProduct = true;
        }
      }
    }
  }

  let deliveryDateMin;
  let deliveryDateMax;

  if (product.deliveryDayMargin && state.settings?.deliveryMaxDays) {
    let date = new Date();
    date.setDate(date.getDate() + product.deliveryDayMargin);
    deliveryDateMin = `${date.getMonth() + 1} сарын ${date.getUTCDate()}`;
    date.setDate(date.getDate() + state.settings.deliveryMaxDays);
    deliveryDateMax = `${date.getMonth() + 1} сарын ${date.getUTCDate()}`;
  }

  return {
    product: product,
    category: category,
    subCategory: subCategory,
    brand: brand,
    categoryProducts: state.products?.filter(
      (p: any) =>
        p.id !== product?.id &&
        p.active &&
        p.brandActive &&
        p.categoryActive &&
        productSharesCategory(p, category?.id) &&
        p.warehouseCount > 0
    ),
    clientLoggedIn: clientLoggedIn,
    savedProduct: savedProduct,
    settings: state.settings,
    deliveryDateMin: deliveryDateMin,
    deliveryDateMax: deliveryDateMax,
    deliveryTime: state.settings.deliveryTime,
    basketCount: basketCount | 0,
    client: state.client,
  };
};

function ProductPage(props: any) {
  const [savedLoading, setSavedLoading] = useState(false);
  const [showBasketMsg, setShowBasketMsg] = useState(false);
  const [showMaxStock, setShowMaxStock] = useState(false);
  const [scrolledUp, setScrolledUp] = useState(false);
  const [fetchedProvider, setFetchedProvider] = useState(false);
  const [provider, setProvider] = useState<ProviderModel>(new ProviderModel());
  const bucket = process.env.REACT_APP_S3_BUCKET;
  const region = process.env.REACT_APP_S3_REGION;

  useEffect(() => {
    const el = document.getElementById("product-page");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [props.match.params.slug]);

  useEffect(() => {
    if (!scrolledUp) {
      let element = document.getElementById("product-page");
      if (element) {
        element.scrollIntoView();
        setScrolledUp(true);
      } else {
        window.scrollTo(0, 100);
        setScrolledUp(true);
      }
    }
    if (
      !props?.basketCount ||
      props?.basketCount < props?.product?.warehouseCount
    ) {
      setShowBasketMsg(false);
      // setShowMaxStock(false)
    }

    if (props.product?.providerId && !fetchedProvider) {
      findProvider();
    }
  }, [props]);

  const findProvider = () => {
    if (isEmpty(props.product.providerId)) {
      return;
    }
    setFetchedProvider(true);

    fetch(
      process.env.REACT_APP_API_URL + "providers/" + props.product.providerId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => {
        if (res.status === 200) {
          res.json().then((res) => {
            if (res.data) {
              if (res.data.imageUrl) {
                res.data.imageUrl = `https://${bucket}.s3.${region}.amazonaws.com/${res.data.imageUrl}`;
              }
              setProvider(res.data);
            }
          });
        }
      })
      .catch((err) => console.error(err));
  };

  const increaseCount = () => {
    if (props.product.warehouseCount === 0) {
      return;
    }
    setShowBasketMsg(props.product?.warehouseCount <= props.basketCount);
    setShowMaxStock(props.product?.warehouseCount <= props.basketCount + 1);
    if (props.product?.warehouseCount < props.basketCount + 1) {
      return;
    }
    store.dispatch({
      type: "addToBasket",
      product: props.product,
      count: 1,
    });
  };

  const decreaseCount = () => {
    if (props.basketCount <= 0) {
      return;
    }
    setShowBasketMsg(false);
    setShowMaxStock(false);
    store.dispatch({
      type: "removeFromBasket",
      product: props.product,
    });
  };

  const onQuantityInputChange = (e: any) => {
    const rawValue = e.target.value;
    if (!rawValue || rawValue === "0") {
      setShowBasketMsg(false);
      setShowMaxStock(false);
      if (props.basketCount > 0) {
        store.dispatch({ type: "updateBasketItemCount", product: props.product, count: "0" });
      }
      return;
    }
    const count = Number(rawValue);
    if (isNaN(count) || count < 0) {
      return;
    }
    if (count > props.product.warehouseCount) {
      setShowMaxStock(true);
      return;
    }
    setShowBasketMsg(count >= props.product.warehouseCount);
    setShowMaxStock(count >= props.product.warehouseCount);
    store.dispatch({ type: "updateBasketItemCount", product: props.product, count: count });
  };

  const onQuantityInputBlur = (e: any) => {
    if (!e.target.value || e.target.value === "0") {
      const basket: any = store.getState().basket;
      const currentQty = basket?.quantityById?.[props.product.id];
      if (currentQty !== undefined && currentQty !== null) {
        store.dispatch({ type: "removeItemFromBasket", product: props.product });
      }
    }
  };

  const getPriceInfo = () => {
    const isClubMember = props.client?.company?.clubMember;
    const effectivePrice = getEffectivePrice(props.product, isClubMember);
    const isSale = props.product.saleActive && props.product.salePrice > 0;
    const isClub = !isSale && isClubMember && props.product.clubPrice > 0;
    const showStrike = effectivePrice !== props.product.price;
    return { effectivePrice, isClubMember, isSale, isClub, showStrike };
  };

  const renderProductPrice = () => {
    const { effectivePrice, isClubMember, isSale, showStrike } = getPriceInfo();
    const p = props.product;
    const hasUnit = p.size && p.unit;

    if (showStrike && isClubMember && !isSale) {
      return (
        <>
          <div className="original-line">
            <span className="original-price">
              <NumberFormat displayType="text" value={p.price} suffix=" ₮" thousandSeparator={true} />
            </span>
            {hasUnit ? <span className="unit-text"> / {p.size} {p.unit}</span> : null}
          </div>
          <div className="price-block discounted">
            <div className="price-type-label club">CLUB PRICE</div>
            <div className="effective-price">
              <NumberFormat displayType="text" value={effectivePrice} suffix=" ₮" thousandSeparator={true} />
            </div>
          </div>
        </>
      );
    }

    if (showStrike && isSale) {
      return (
        <>
          <div className="original-line">
            <span className="original-price">
              <div className="price-type-label sale">SALE</div>
              <NumberFormat displayType="text" value={p.price} suffix=" ₮" thousandSeparator={true} />
            </span>
          </div>
          <div className="price-block">
            <div className="effective-price">
              <NumberFormat displayType="text" value={p.salePrice} suffix=" ₮" thousandSeparator={true} />
              {hasUnit ? <span className="unit-text"> / {p.size} {p.unit}</span> : null}
            </div>
          </div>
        </>
      );
    }

    return (
      <span className="price">
        <NumberFormat displayType="text" value={p.price} suffix="₮" thousandSeparator={true} />
        {hasUnit ? <span className="price-per"> / {p.size} {p.unit}</span> : null}
      </span>
    );
  };

  const renderUnitPriceLine = () => {
    const { effectivePrice } = getPriceInfo();
    const count = props.basketCount || 0;
    const hasUnit = props.product.size && props.product.unit;
    return (
      <div className="product-unit-price-line" data-testid="product-unit-price-line">
        <NumberFormat displayType="text" value={effectivePrice} suffix="₮" thousandSeparator={true} />
        {hasUnit ? (
          <span className="price-per"> / {props.product.size} {props.product.unit}</span>
        ) : null}
        {count > 0 ? (
          <span className="line-total-calc">
            &nbsp;x {count} ={' '}
            <NumberFormat displayType="text" value={effectivePrice * count} suffix="₮" thousandSeparator={true} />
          </span>
        ) : null}
      </div>
    );
  };

  const renderQuantitySelector = () => (
    <div className="quantity-selector">
      <button
        type="button"
        className="qty-btn"
        onClick={decreaseCount}
        disabled={props.basketCount <= 0}
        data-testid="product-qty-minus"
      >
        -
      </button>
      <input
        type="number"
        min={0}
        value={props.basketCount}
        onChange={onQuantityInputChange}
        onBlur={onQuantityInputBlur}
        onFocus={(e: any) => e.target.select()}
        className="qty-input"
        data-testid="product-qty-value"
      />
      <button
        type="button"
        className="qty-btn qty-btn-add"
        onClick={increaseCount}
        disabled={
          props.product.warehouseCount === 0 ||
          props.basketCount >= props.product.warehouseCount
        }
        data-testid="product-qty-add"
      >
        <MdOutlineShoppingBag className="qty-cart-icon" />
      </button>
    </div>
  );

  const toggleSavedProduct = () => {
    let token = localStorage.getItem("clientToken");
    if (token && token !== undefined) {
      if (props.savedProduct) {
        setSavedLoading(true);
        // remove from the saved products
        fetch(
          process.env.REACT_APP_API_URL + "client/product/" + props.product.id,
          {
            method: "DELETE",
            headers: {
              Accept: "application/json",
              Authorization: token,
              "Content-Type": "application/json",
            },
          }
        )
          .then((res: any) => {
            setSavedLoading(false);
            if (res.ok) {
              store.dispatch({
                type: "removeSavedProduct",
                data: props.product.id,
              });
            }
          })
          .catch((err: any) => {
            setSavedLoading(false);
            console.error(err);
          });
      } else {
        setSavedLoading(true);
        // add to the saved products
        fetch(process.env.REACT_APP_API_URL + "client/product", {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            productId: props.product.id,
          }),
        })
          .then((res: any) => {
            setSavedLoading(false);
            if (res.ok) {
              store.dispatch({
                type: "addSavedProduct",
                data: props.product.id,
              });
            }
          })
          .catch((err: any) => {
            setSavedLoading(false);
            console.error(err);
          });
      }
    }
  };

  return (
    <React.Fragment>
      {props.product && props.category ? (
        <div id="product-page" className="page product-page">
          {/* Mobile screen */}
          <div id="mobile-container" className="mobile-container">
            <div className="breadcrumb">
              <Link
                to={"/category/" + props.category?.slug}
                className="category"
              >
                {props.category?.name}
              </Link>
              {props.subCategory && props.subCategory.id ? (
                <React.Fragment>
                  &nbsp;<Icon name="angle right"></Icon>
                  <Link
                    to={
                      "/category/" +
                      props.category?.id +
                      "/" +
                      props.subCategory?.id
                    }
                    className="sub-category"
                  >
                    {props.subCategory?.name}
                  </Link>
                </React.Fragment>
              ) : null}
              {props.brand && props.brand.id ? (
                <React.Fragment>
                  &nbsp;<Icon name="angle right"></Icon>
                  <Link to={"/brand/" + props.brand?.slug} className="brand">
                    {props.brand?.name}
                  </Link>
                </React.Fragment>
              ) : null}
            </div>
            <div className="product-section flex-div">
              <img
                className="main-product-image"
                src={props.product.imageSmUrl}
              />
            </div>
            <h2>
              {props.product?.name}
              {props.product.size && props.product.unit ? (
                <span className="price-per">
                  &nbsp;{"("}
                  {props.product.size + " " + props.product.unit}
                  {")"}
                </span>
              ) : null}
            </h2>
            <div className="product-price-line">
              {renderProductPrice()}
            </div>
            {/* {!showBasketMsg && props.basketCount > 0 ? (
              <div className="basket-count">{`Сагсанд энэ бүтээгдэхүүн ${props.basketCount} байна`}</div>
            ) : null} */}
            {showBasketMsg ? (
              <div className="warehouse-line">
                Сагсанд бүх боломжит үлдэгдэл нэмэгдсэн байна
              </div>
            ) : null}
            {showMaxStock ? (
              <div className="warehouse-line">
                {"Нийт боломжит үлдэгдэл: " + props.product.warehouseCount}
              </div>
            ) : null}
            {showMaxStock &&
            props.product?.warehouseCount - props?.basketCount > 0 ? (
              <div className="basket-msg">{`Сагсанд дахин ${
                props.product?.warehouseCount - props?.basketCount
              }-г нэмэх боломжтой`}</div>
            ) : null}
            {props.product.warehouseCount === 0 ? (
              <div className="warehouse-line">Үлдэгдэл байхгүй</div>
            ) : null}
            <div className="basket-line">
              {renderQuantitySelector()}
              <p>{props.product.warehouseCount} ширхэг бэлэн байна</p>
            </div>
            {renderUnitPriceLine()}
            {props.clientLoggedIn ? (
              <div className="save-line">
                <Button
                  className="ui button"
                  color="grey"
                  disabled={savedLoading}
                  onClick={() => toggleSavedProduct()}
                >
                  {savedLoading ? (
                    <Loader active={true} inverted size="small"></Loader>
                  ) : props.savedProduct ? (
                    <span className="cursor">
                      <Icon name="heart" color="red" />
                      &nbsp;&nbsp;
                      <span className="text">Хадгалсан</span>
                    </span>
                  ) : (
                    <span className="cursor">
                      <Icon name="heart" />
                      &nbsp;&nbsp;
                      <span className="text">Хадгалах</span>
                    </span>
                  )}
                </Button>
              </div>
            ) : null}
            {props.deliveryDateMax ? (
              <div className="delivery-line">
                <span className="icon-truck">
                  <PiTruckFill size={40} color="#f44236">
                    &nbsp;
                  </PiTruckFill>
                </span>
                <span className="text">{`${props.deliveryDateMin}-с ${props.deliveryDateMax}-ны хооронд ${props.deliveryTime} цагын хооронд хүргэх боломжтой.`}</span>
              </div>
            ) : null}
            {/* <div className="product-section product-detail-images">
              {props.product.image1 ? (
                <div className="product-detail-image">
                  <img className="detail-image" src={props.product.image1} />
                </div>
              ) : null}
              {props.product.image2 ? (
                <div className="product-detail-image">
                  <br />
                  <br />
                  <img className="detail-image" src={props.product.image2} />
                </div>
              ) : null}
              {props.product.image3 ? (
                <div className="product-detail-image">
                  <br />
                  <br />
                  <img className="detail-image" src={props.product.image3} />
                </div>
              ) : null}
            </div> */}

            {props.product.providerId && provider?.imageUrl ? (
              <>
                <div className="brand-line">
                  <Link to={"/providers/" + provider?.id}>
                    <div className="flex-div">
                      <img className="brand-image" src={provider?.imageUrl} />
                    </div>
                    <span>{provider?.name}-н бусад бүтээгдэхүүнүүд</span>
                  </Link>
                </div>
                <hr />
              </>
            ) : null}
            <div className="brand-line">
              <Link to={"/brand/" + props.brand?.slug}>
                <div className="flex-div">
                  <img className="brand-image" src={props.brand?.imageXsUrl} />
                </div>
                <div className="text">
                  {props.brand?.name} брэндийн бусад бүтээгдэхүүнүүд
                </div>
              </Link>
            </div>

            <div className="product-section top-products-section">
              {props.categoryProducts?.length > 0 ? (
                <TopProducts
                  title="Төстэй бүтээгдэхүүн"
                  products={props.categoryProducts.map((i: any) => (
                    <TopProductItem product={i} />
                  ))}
                />
              ) : null}
            </div>
          </div>

          {/* Desktop and Tablet */}
          <Container
            fluid={true}
            className="product-page-container"
            id="product-page-container"
          >
            <Row>
              <Col className="breadcrumb">
                <Link
                  to={"/category/" + props.category?.slug}
                  className="category"
                >
                  {props.category?.name}
                </Link>
                {props.subCategory && props.subCategory.id ? (
                  <React.Fragment>
                    &nbsp;<Icon name="angle right"></Icon>
                    <Link
                      to={
                        "/category/" +
                        props.category?.id +
                        "/" +
                        props.subCategory?.id
                      }
                      className="sub-category"
                    >
                      {props.subCategory?.name}
                    </Link>
                  </React.Fragment>
                ) : null}
                {props.brand && props.brand.id ? (
                  <React.Fragment>
                    &nbsp;<Icon name="angle right"></Icon>
                    <Link to={"/brand/" + props.brand?.slug} className="brand">
                      {props.brand?.name}
                    </Link>
                  </React.Fragment>
                ) : null}
              </Col>
            </Row>
            <Row>
              <Col xs={7} sm={7} md={7} className="product-left">
                <div className="product">
                  <div
                    className="product-section flex-div"
                    style={{ justifyContent: "flex-start" }}
                  >
                    <img
                      className="main-product-image"
                      src={props.product.imageLgUrl}
                    />
                  </div>

                  <div className="product-section product-desc">
                    {props.product.info}
                  </div>

                  <div className="product-section product-detail-images">
                    {props.product.image1 ? (
                      <div className="product-detail-image">
                        <img
                          className="detail-image"
                          src={props.product.image1}
                        />
                      </div>
                    ) : null}
                    {props.product.image2 ? (
                      <div className="product-detail-image">
                        <br />
                        <br />
                        <img
                          className="detail-image"
                          src={props.product.image2}
                        />
                      </div>
                    ) : null}
                    {props.product.image3 ? (
                      <div className="product-detail-image">
                        <br />
                        <br />
                        <img
                          className="detail-image"
                          src={props.product.image3}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </Col>

              <Col xs={5} sm={5} md={5} className="product-right">
                <div className="product-right-inner">
                  <h2>
                    {props.product?.name}
                    {props.product.size && props.product.unit ? (
                      <span className="price-per">
                        ({props.product.size + " " + props.product.unit})
                      </span>
                    ) : null}
                  </h2>
                  <div className="product-price-line">
                    {renderProductPrice()}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "20px",
                      alignItems: "center",
                      marginBottom: "20px",
                    }}
                  >
                    {renderQuantitySelector()}
                    <p>{props.product.warehouseCount} ширхэг бэлэн байна</p>
                  </div>
                  {renderUnitPriceLine()}

                  {/* <div className="right-section"> */}
                  {/* <div className="product-price-line"> */}
                  {/* {props.product.saleActive ? (
                        <React.Fragment>
                          <div className="price">
                            <NumberFormat
                              displayType={"text"}
                              value={props.product.salePrice}
                              suffix="₮"
                              thousandSeparator={true}
                            />
                            {props.product.size && props.product.unit ? (
                              <span className="price-per">
                                &nbsp;/&nbsp;
                                {props.product.size + " " + props.product.unit}
                              </span>
                            ) : null}
                          </div>
                          <div className="price striked">
                            <NumberFormat
                              displayType={"text"}
                              value={props.product.price}
                              suffix="₮"
                              thousandSeparator={true}
                            />
                            {props.product.size && props.product.unit ? (
                              <span className="price-per">
                                &nbsp;/&nbsp;
                                {props.product.size + " " + props.product.unit}
                              </span>
                            ) : null}
                          </div>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <span className="price">
                            <NumberFormat
                              displayType={"text"}
                              value={props.product.price}
                              suffix="₮"
                              thousandSeparator={true}
                            />
                          </span>
                          {props.product.size && props.product.unit ? (
                            <span className="price-per">
                              &nbsp;/&nbsp;
                              {props.product.size + " " + props.product.unit}
                            </span>
                          ) : null}
                        </React.Fragment>
                      )} */}
                  {/* </div> */}

                  {!showBasketMsg && props.basketCount > 0 ? (
                    <div className="basket-count">{`Сагсанд энэ бүтээгдэхүүн ${props.basketCount} байна`}</div>
                  ) : null}
                  {showBasketMsg ? (
                    <div className="warehouse-line">
                      Сагсанд бүх боломжит үлдэгдэл нэмэгдсэн байна
                    </div>
                  ) : null}
                  {showMaxStock ? (
                    <div className="warehouse-line">
                      {"Нийт боломжит үлдэгдэл: " +
                        props.product.warehouseCount}
                    </div>
                  ) : null}
                  {showMaxStock &&
                  props.product?.warehouseCount - props?.basketCount > 0 ? (
                    <div className="basket-msg">{`Сагсанд дахин ${
                      props.product?.warehouseCount - props?.basketCount
                    }-г нэмэх боломжтой`}</div>
                  ) : null}
                  {props.product.warehouseCount === 0 ? (
                    <div className="warehouse-line">Үлдэгдэл байхгүй</div>
                  ) : null}

                  {props.clientLoggedIn ? (
                    <div className="save-line">
                      <Button
                        className="ui button"
                        color="grey"
                        disabled={savedLoading}
                        onClick={() => toggleSavedProduct()}
                      >
                        {savedLoading ? (
                          <Loader
                            active={true}
                            inverted
                            size="small"
                            color="white"
                          />
                        ) : props.savedProduct ? (
                          <span className="cursor">
                            <Icon name="heart" color="red" />
                            &nbsp;&nbsp;
                            <span className="text">Хадгалсан</span>
                          </span>
                        ) : (
                          <span className="cursor">
                            <Icon name="heart" />
                            &nbsp;&nbsp;
                            <span className="text">Хадгалах</span>
                          </span>
                        )}
                      </Button>
                    </div>
                  ) : null}

                  {props.deliveryDateMax ? (
                    <div className="delivery-line">
                      <span className="icon-truck">
                        <PiTruckFill size={50} color="#f44236">
                          &nbsp;
                        </PiTruckFill>
                      </span>
                      <span className="text">{`${props.deliveryDateMin}-с ${props.deliveryDateMax}-ны хооронд ${props.deliveryTime} цагын хооронд хүргэх боломжтой.`}</span>
                    </div>
                  ) : null}

                  {props.product.providerId && provider?.imageUrl ? (
                    <div className="brand-line">
                      <Link to={"/providers/" + provider?.id}>
                        <img className="brand-image" src={provider?.imageUrl} />
                        <span>{provider?.name}-н бусад бүтээгдэхүүнүүд</span>
                      </Link>
                    </div>
                  ) : null}

                  <div className="brand-line">
                    <Link to={"/brand/" + props.brand?.slug}>
                      <img
                        className="brand-image"
                        src={props.brand?.imageXsUrl}
                      />
                      <span className="text">
                        {props.brand?.name} брэндийн бусад бүтээгдэхүүнүүд
                      </span>
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>
            <div className="product-section top-products-section">
              {props.categoryProducts?.length > 0 ? (
                <TopProducts
                  title="Төстэй бүтээгдэхүүн"
                  products={props.categoryProducts?.map((i: any) => (
                    <TopProductItem product={i} />
                  ))}
                />
              ) : null}
            </div>
          </Container>
        </div>
      ) : (
        <Dimmer active={true}>
          <Loader size="medium"></Loader>
        </Dimmer>
      )}
    </React.Fragment>
  );
}

export default connect(mapStateToProps)(ProductPage);
